var React = require('react');

function FrequencyOptimization (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.9 0H1C.4 0 0 .4 0 1v53.2c0 .6.4 1 1 1h4.9c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 53.2H2V2h2.9v51.2zm10.5-42h-4.9c-.6 0-1 .4-1 1v42.1c0 .6.4 1 1 1h4.9c.6 0 1-.4 1-1V12.2c0-.6-.5-1-1-1zm-1 42h-2.9v-40h2.9v40zM24.9 21H20c-.6 0-1 .4-1 1v32.2c0 .6.4 1 1 1h4.9c.6 0 1-.4 1-1V22c0-.6-.5-1-1-1zm-1 32.2H21V23h2.9v30.2zm10.4-39.6h-4.9c-.6 0-1 .4-1 1v39.7c0 .6.4 1 1 1h4.9c.6 0 1-.4 1-1V14.6c0-.6-.4-1-1-1zm-1 39.6h-2.9V15.6h2.9v37.6zM43.8 5h-4.9c-.6 0-1 .4-1 1v48.2c0 .6.4 1 1 1h4.9c.6 0 1-.4 1-1V6c0-.6-.5-1-1-1zm-1 48.2h-2.9V7h2.9v46.2zm10.4-23.1h-4.9c-.6 0-1 .4-1 1v23.1c0 .6.4 1 1 1h4.9c.6 0 1-.4 1-1V31.1c0-.5-.4-1-1-1zm-1 23.1h-2.9V32.1h2.9v21.1z"}));
}

FrequencyOptimization.defaultProps = {"fill":"currentColor","viewBox":"0 0 54.2 55.2","id":"frequency-optimization"};

module.exports = FrequencyOptimization;

FrequencyOptimization.default = FrequencyOptimization;
